export default __webpack_public_path__ + "static/media/Scholar's Leggings of the Burning Disc.6b53ca57.jpg";